<template>
  <div class="flex justify-center pt-10">
    <div class="container flex flex-col items-center">
      <aha-logo
        width="156"
        height="26"
        viewBox="0 0 9600 1602"
        class="mb-8"
      />
      <h2 class="text-center mb-8 px-4">
        Make your Zoom meeting awesome with AhaSlides
      </h2>
      <div class="w-full flex flex-col p-4">
        <div class="zoom-action p-4 w-full cursor-pointer h-16 mb-4 rounded-lg flex justify-between items-center" @click="startAuthorizePresenter">
          <span class="font-bold text-base">Host a presentation</span>
          <span>
            <img src="@/assets/images/zoom/zoom_host.svg" />
          </span>
        </div>
        <div class="zoom-action p-4 w-full cursor-pointer mb-4 h-16 rounded-lg flex justify-between items-center" @click="openAudienceApp">
          <span class="font-bold text-base">Join as a Participant</span>
          <span>
            <img src="@/assets/images/zoom/zoom_participant.svg" />
          </span>
        </div>
      </div>
      <div class="text-base-50 text-xs absolute bottom-3">
        v{{ zoomAppVersion }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'
import cookie from '@/services/cookie'

export default {
  name: 'ZoomStarterPage',
  data() {
    return {
      zoomAppVersion: '1.1.0-20250416',
    }
  },
  mounted() {
    if (cookie.getValue('is-auth-pending') && cookie.getValue('ahaToken')) {
      cookie.deleteValue('is-auth-pending')
      this.$router.push({
        name: 'Presentations',
        query: {
          zoomApp: true,
        },
      })
    }
  },
  methods: {
    ...mapActions('zoomApp', [
      'openLoginPageAction',
    ]),
    openAudienceApp() {
      this.$router.push({
        name: 'ZoomAudienceApp',
      })
    },

    startAuthorizePresenter() {
      if (cookie.getValue('ahaToken')) {
        this.$router.push({
          name: 'ZoomPresentationList',
          query: {
            zoomApp: true,
          },
        })
      } else {
        this.openLoginPageInBrowser()
      }
    },

    async openLoginPageInBrowser() {
      try {
        await this.openLoginPageAction()
      } catch (e) {
        Sentry.captureException(e)
        console.error(`Error when openLoginPageInBrowser: ${e}`)
      }
    },

  },
}
</script>

<style lang="scss" scoped>
/* Your component's styles go here */
.container {
  width: 100%;
  max-width: 420px;
}

.zoom-action {
  -webkit-transform-style: preserve-3d;
  -webkit-backface-visibility: hidden;
  -webkit-transform: translateZ(0);
  @apply bg-base-0 shadow-base-md;

  ::after {
    content: "";
    @apply absolute -top-0.25 right-0 h-0.25;
  }

  &:hover {
    transform: translateY(1px);
    box-shadow: 0px 2px 0px #DFE3E9;

    ::after {
      @apply h-0.5 -top-0.5;
    }
  }

  &:active:not(:disabled) {
    transform: translateY(4px);
    box-shadow: none;
    @apply bg-base-0-65;
  }
}
</style>
